import { NumberFormatInput } from "components/FormControls/NumberFormatInput";
import { RequiredFieldLabel } from "components/FormControls/RequiredFieldLabel";
import { useMessage } from "hooks/intl";
import { get } from "lodash";
import { AgeType } from "types/segments";
import { formatNumberValue } from "utilities/numbers";
import { BoxElement } from "./BoxElement";
import { useStyles } from "./SegmentConditions.styles";

export const initialValuesAge: AgeType = {
  fromAge: 0,
  toAge: 0,
  type: "age",
};

export function Age({
  formField,
  values,
  status,
  readOnly,
}: {
  formField: string;
  values: any;
  status: any;
  readOnly?: boolean;
}) {
  const classes = useStyles();
  const { message } = useMessage();
  const value = get(values, formField);
  const fromAgeError = get(status, "fromAge");
  const toAgeError = get(status, "toAge");

  return (
    <>
      {value.isConditionSaved || readOnly ? (
        <>
          {message({ id: "from" }).toLocaleLowerCase()}
          <BoxElement
            content={formatNumberValue(value?.fromAge, "")}
            error={fromAgeError}
          />
          {message({ id: "to" }).toLocaleLowerCase()}
          <BoxElement
            content={formatNumberValue(value?.toAge, "")}
            error={toAgeError}
          />
        </>
      ) : (
        <>
          <NumberFormatInput
            allowNegative={false}
            name={`${formField}.fromAge`}
            className={classes.input}
            label={<RequiredFieldLabel text={message({ id: "ageFrom" })} />}
            data-test-id="segment-conditions-from-age"
          />
          <NumberFormatInput
            allowNegative={false}
            name={`${formField}.toAge`}
            className={classes.input}
            label={<RequiredFieldLabel text={message({ id: "ageTo" })} />}
            data-test-id="segment-conditions-to-age"
          />
        </>
      )}
    </>
  );
}
